import { ShimmerBlock } from './Shimmer'

function GridSection({ label, cards = 3 }: { label: string; cards?: number }) {
  return (
    <section className="hp-section hp-section--white">
      <div className="hp-section-inner">
        <div className="hp-section-head">
          <div>
            <ShimmerBlock width={140} height={12} style={{ marginBottom: 10 }} />
            <ShimmerBlock width={260} height={26} />
          </div>
        </div>
        <div className="entity-grid">
          {Array.from({ length: cards }).map((_, i) => (
            <div className="entity-card" key={`${label}-${i}`}>
              <ShimmerBlock className="entity-cover" width="100%" height={150} radius={0} />
              <div className="entity-body">
                <ShimmerBlock width="70%" height={20} style={{ marginBottom: 8 }} />
                <ShimmerBlock width="45%" height={13} />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export function HomeSkeleton() {
  return (
    <>
      <section className="hp-hero">
        <div className="hp-hero-bg skel" />
        <div className="hp-hero-overlay" />
        <div className="hp-hero-content">
          <ShimmerBlock width={220} height={12} style={{ marginBottom: 18 }} />
          <ShimmerBlock width="60%" height={54} style={{ marginBottom: 18 }} />
          <ShimmerBlock width={200} height={16} style={{ marginBottom: 30 }} />
          <div style={{ display: 'flex', gap: 12 }}>
            <ShimmerBlock width={160} height={46} />
            <ShimmerBlock width={160} height={46} />
          </div>
        </div>
      </section>

      <section className="hp-section hp-section--events">
        <div className="hp-section-inner">
          <div className="hp-section-head">
            <ShimmerBlock width={220} height={26} />
          </div>
          <div className="hp-events-featured-grid">
            <div className="hp-ev-feat">
              <ShimmerBlock width="100%" height="100%" />
            </div>
            <div className="hp-ev-upcoming-col">
              {[0, 1, 2].map(i => (
                <div className="hp-ev-small" key={i}>
                  <ShimmerBlock className="hp-ev-small-img" width={64} height={64} radius={0} />
                  <div className="hp-ev-small-body">
                    <ShimmerBlock width="70%" height={14} style={{ marginBottom: 6 }} />
                    <ShimmerBlock width="45%" height={12} />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <GridSection label="clusters" cards={3} />
      <GridSection label="places" cards={6} />

      <section className="hp-section hp-section--map">
        <ShimmerBlock width="100%" height={360} radius={0} />
      </section>

      <GridSection label="news" cards={3} />
    </>
  )
}
